import grand from "../assets/grandkenya.jpg";
import karibu from "../assets/karibukenya.jpg";
import twiga from "../assets/twiga.jpg";
import amboseli from "../assets/amboseli.jpg";
import naivasha from "../assets/naivasha.jpg";
import mara from "../assets/mara.jpg";
import zebra from "../assets/zebra.jpg";
import marasun from "../assets/marasun.jpg";
import easymara from "../assets/easymara.jpg";
import kenyasaf from "../assets/lioncub.jpg";

export const safariPackages = [
    {
      id: "JT001",
      name: "Grand Kenya (Classic)",
      duration: "9 Days / 8 Nights",
      description: "Experience the ultimate Kenya adventure with our most comprehensive safari package, covering the best national parks and reserves across the country.",
      highlights: [
        "Big Five wildlife viewing",
        "Visit to multiple national parks",
        "Cultural experiences with local tribes",
        "Luxury accommodations throughout"
      ],
      difficulty: "Moderate",
      featured: true,
      destinations: ["Masai Mara", "Amboseli", "Lake Nakuru", "Samburu"],
      coverImage: grand,
      itinerary: [
    {
      "day": "Day 01",
      "title": "Arrival In Nairobi",
      "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)."
    },
    {
      "day": "Day 02",
      "title": "Nairobi/Samburu National Reserve",
      "description": "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some of the best and most colorful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Samburu Simba Lodge (LDBB)."
    },
    {
      "day": "Day 03",
      "title": "Samburu National Reserve",
      "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Samburu Simba Lodge (LDBB)."
    },
    {
      "day": "Day 04",
      "title": "Samburu National Reserve/Mount Kenya National Park",
      "description": "After breakfast drive to the Mount Kenya National Park arriving in time for lunch at The Serena Mountain Lodge. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at Serena Mountain Lodge (LDBB)."
    },
    {
      "day": "Day 05",
      "title": "Mount Kenya National Park/Lake Nakuru National Park",
      "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)."
    },
    {
      "day": "Day 06",
      "title": "Lake Nakuru National Park/Masai Mara National Reserve",
      "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)."
    },
    {
      "day": "Day 07",
      "title": "Masai Mara National Reserve",
      "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)."
    },
    {
      "day": "Day 08",
      "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
      "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow-capped mountain. Game drive enroute to your lodge. Dinner and overnight at Amboseli Serena Lodge (LDBB)."
    },
    {
      "day": "Day 09",
      "title": "Amboseli National Park",
      "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Serena Lodge (LDBB)."
    },
    {
      "day": "Day 10",
      "title": "Amboseli National Park/Nairobi/Departure",
      "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
    }
  ]
    },
    {
        id: "JT002",
        name: "Karibu Kenya (Classic)",
        duration: "10 Days / 9 Nights",
        description: "A warm welcome to Kenya with this classic safari experience that showcases the country's incredible biodiversity and landscapes.",
        highlights: [
          "Game drives in premier wildlife reserves", 
          "Professional safari guides",
          "Comfortable lodge accommodations",
          "Cultural interactions"
        ],
        seasons: [
          { "period": "02.01-30.03.2025", "sharedPrice": 2952.05, "singleSupplement": 553.15 },
          { "period": "01.04-30.06.2025", "sharedPrice": 2715.15, "singleSupplement": 155.25 },
          { "period": "01.07-31.10.2025", "sharedPrice": 3193.55, "singleSupplement": 631.35 },
          { "period": "01.11-15.12.2025", "sharedPrice": 2938.25, "singleSupplement": 545.10 }
        ],
        difficulty: "Easy to Moderate",
        featured: true,
        destinations: ["Masai Mara", "Lake Nakuru", "Aberdares", "Samburu", "Amboseli", "Lake Naivasha"],
        coverImage: karibu,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)."
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Samburu National Reserve",
            "description": "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some the best and most colourful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Samburu Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 03",
            "title": "Samburu National Reserve",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Samburu Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 04",
            "title": "Samburu National Reserve/Aberdare National Park",
            "description": "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
          },
          {
            "day": "Day 05",
            "title": "Aberdare National Park/Lake Nakuru National Park/Lake Naivasha",
            "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. After lunch proceed for a game drive and thereafter continue to Lake Naivasha arriving in the late afternoon for dinner and overnight at Lake Naivasha Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 06",
            "title": "Lake Naivasha/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 07",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 08",
            "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Amboseli Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 09",
            "title": "Amboseli National Park",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Sopa Lodge (LDBB)."
          },
          {
            "day": "Day 10",
            "title": "Amboseli National Park/Nairobi/Departure",
            "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT003",
        name: "Twiga Safari (Classic)",
        duration: "10 Days / 9 Nights",
        description: "Named after the Swahili word for giraffe, this safari offers towering views of Kenya's most magnificent landscapes and wildlife.",
        highlights: [
          "Premium wildlife viewing opportunities",
          "Comfortable accommodations in the heart of the wilderness",
          "Expert naturalist guides",
          "Multiple national parks exploration"
        ],
        seasons: [
          { "period": "02.01-30.03.2025", "sharedPrice": 3251.05, "singleSupplement": 1024.65 },
          { "period": "01.04-30.06.2025", "sharedPrice": 3093.50, "singleSupplement": 474.95 },
          { "period": "01.07-31.10.2025", "sharedPrice": 3806.50, "singleSupplement": 1276.50 },
          { "period": "01.11-15.12.2025", "sharedPrice": 3174.00, "singleSupplement": 834.90 }
        ],
        difficulty: "Moderate",
        destinations: ["Masai Mara", "Samburu", "Amboseli", "Lake Nakuru", "Mount Kenya", "Aberdare"],
        coverImage: twiga,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)."
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Samburu National Reserve",
            "description": "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some the best and most colourful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Shaba Lodge (LDBB)."
          },
          {
            "day": "Day 03",
            "title": "Samburu National Reserve",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Sarova Shaba Lodge (LDBB)."
          },
          {
            "day": "Day 04",
            "title": "Samburu National Reserve/Aberdare National Park",
            "description": "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
          },
          {
            "day": "Day 05",
            "title": "Aberdare National Park/Lake Nakuru National Park",
            "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)."
          },
          {
            "day": "Day 06",
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)."
          },
          {
            "day": "Day 07",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)."
          },
          {
            "day": "Day 08",
            "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Oltukai Lodge (LDBB)."
          },
          {
            "day": "Day 09",
            "title": "Amboseli National Park",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Oltukai Lodge (LDBB)."
          },
          {
            "day": "Day 10",
            "title": "Amboseli National Park/Nairobi/Departure",
            "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT004",
        name: "Kenya Horizons (Classic)",
        duration: "8 Days / 7 Nights",
        description: "Discover the breathtaking horizons of Kenya's diverse landscapes, from savannah plains to mountain vistas.",
        highlights: [
          "Scenic panoramic views",
          "Diverse ecosystems exploration",
          "Big Five wildlife sightings",
          "Comfortable safari lodges"
        ],
        seasons: [
          { "period": "02.01-30.03.2025", "sharedPrice": 2608.20, "singleSupplement": 767.05 },
          { "period": "01.04-30.06.2025", "sharedPrice": 2410.40, "singleSupplement": 353.05 },
          { "period": "01.07-31.10.2025", "sharedPrice": 3022.20, "singleSupplement": 861.35 },
          { "period": "01.11-15.12.2025", "sharedPrice": 2439.15, "singleSupplement": 591.10 }
        ],
        difficulty: "Easy",
        destinations: ["Masai Mara", "Lake Nakuru", "Mount Kenya", "Samburu"],
        coverImage: amboseli,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)."
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Samburu National Reserve",
            "description": "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some the best and most colourful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Samburu Simba Lodge (LDBB)"
          },
          {
            "day": "Day 03",
            "title": "Samburu National Reserve",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Samburu Simba Lodge (LDBB)"
          },
          {
            "day": "Day 04",
            "title": "Samburu National Reserve/Mount Kenya National Park",
            "description": "After breakfast drive to the Mount Kenya National Park arriving in time for lunch at The Serena Mountain Lodge. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at Serena Mountain Lodge (LDBB)"
          },
          {
            "day": "Day 05",
            "title": "Mount Kenya National Park/Lake Nakuru National Park",
            "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)"
          },
          {
            "day": "Day 06",
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": "Day 07",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": "Day 08",
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
    {
      id: "JT005",
      name: "Kenya Footsteps (Classic)",
      duration: "8 Days / 7 Nights",
      description: "Follow in the footsteps of Kenya's amazing wildlife with this compact but comprehensive safari experience.",
      highlights: [
        "Concentrated wildlife viewing",
        "Premium safari vehicles",
        "Expert tracking guides",
        "Conservation insights"
      ],
      seasons: [
        { period: "02.01-30.03.2025", sharedPrice: 2362.10, singleSupplement: 448.50 },
        { period: "01.04-30.06.2025", sharedPrice: 2165.45, singleSupplement: 156.40 },
        { period: "01.07-31.10.2025", sharedPrice: 2556.45, singleSupplement: 512.90 },
        { period: "01.11-15.12.2025", sharedPrice: 2349.45, singleSupplement: 441.60 }
      ],
      difficulty: "Easy",
      destinations: ["Masai Mara", "Lake Naivasha", "Samburu", "Aberdare", "Mount Kenya"],
      coverImage: naivasha,
      itinerary: [
        {
          day: "Day 01",
          title: "Arrival In Nairobi",
          description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)."
        },
        {
          day: "Day 02",
          title: "Nairobi/Samburu National Reserve",
          description: "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some the best and most colourful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Samburu Sopa Lodge (LDBB)."
        },
        {
          day: "Day 03",
          title: "Samburu National Reserve",
          description: "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Samburu Sopa Lodge (LDBB)."
        },
        {
          day: "Day 04",
          title: "Samburu National Reserve/Aberdare National Park",
          description: "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
        },
        {
          day: "Day 05",
          title: "Aberdare National Park/Lake Nakuru National Park/Lake Naivasha",
          description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. After lunch proceed for a game drive and thereafter continue to Lake Naivasha arriving in the late afternoon for dinner and overnight at Lake Naivasha Sopa Lodge (LDBB)."
        },
        {
          day: "Day 06",
          title: "Lake Naivasha/Masai Mara National Reserve",
          description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)."
        },
        {
          day: "Day 07",
          title: "Masai Mara National Reserve",
          description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)."
        },
        {
          day: "Day 08",
          title: "Masai Mara National Reserve/Nairobi/Departure",
          description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
        }
      ]
    },
    {
      id: "JT006",
      name: "Classic Kenya Safari",
      duration: "8 Days / 7 Nights",
      description: "The quintessential Kenyan safari experience featuring the most iconic wildlife destinations and comfortable accommodations.",
      highlights: [
        "Big Five game viewing",
        "Scenic drives through diverse landscapes",
        "Bird watching opportunities",
        "Comfortable safari lodges"
      ],
      seasons: [
        { period: "02.01-30.03.2025", sharedPrice: 2503.55, singleSupplement: 661.25 },
        { period: "01.04-30.06.2025", sharedPrice: 2375.90, singleSupplement: 474.95 },
        { period: "01.07-31.10.2025", sharedPrice: 2945.15, singleSupplement: 969.45 },
        { period: "01.11-15.12.2025", sharedPrice: 2426.50, singleSupplement: 474.95 }
      ],
      difficulty: "Moderate",
      destinations: ["Masai Mara", "Lake Nakuru", "Amboseli", "Samburu"],
      coverImage: mara,
      itinerary: [
        {
          day: "Day 01",
          title: "Arrival In Nairobi",
          description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)."
        },
        {
          day: "Day 02",
          title: "Nairobi/Samburu National Reserve",
          description: "After breakfast, drive north via Nanyuki and Mt Kenya to the Samburu National Reserve. Rugged and remote, this wildlife reserve provides some the best and most colourful game viewing in the country arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Shaba Lodge (LDBB)."
        },
        {
          day: "Day 03",
          title: "Samburu National Reserve",
          description: "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Sarova Shaba Lodge (LDBB)."
        },
        {
          day: "Day 04",
          title: "Samburu National Reserve/Aberdare National Park",
          description: "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
        },
        {
          day: "Day 05",
          title: "Aberdare National Park/Lake Nakuru National Park",
          description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)."
        },
        {
          day: "Day 06",
          title: "Lake Nakuru National Park/Masai Mara National Reserve",
          description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)."
        },
        {
          day: "Day 07",
          title: "Masai Mara National Reserve",
          description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)."
        },
        {
          day: "Day 08",
          title: "Masai Mara National Reserve/Nairobi/Departure",
          description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
        }
      ]
    },
    {
      id: "JT007",
      name: "Kenya Highlights Safari (Classic)",
      duration: "8 Days / 7 Nights",
      description: "A condensed safari focusing on Kenya's highlight destinations and most remarkable wildlife experiences.",
      highlights: [
        "Key wildlife viewing areas",
        "Efficient itinerary",
        "Quality accommodations",
        "Professional guiding"
      ],
      seasons: [
        { period: "02.01-30.03.2025", sharedPrice: 1743.40, singleSupplement: 343.85 },
        { period: "01.04-30.06.2025", sharedPrice: 1584.70, singleSupplement: 154.10 },
        { period: "01.07-31.10.2025", sharedPrice: 1890.60, singleSupplement: 393.30 },
        { period: "01.11-15.12.2025", sharedPrice: 1730.75, singleSupplement: 335.80 }
      ],
      difficulty: "Easy",
      destinations: ["Masai Mara", "Lake Nakuru", "Mount Kenya", "Amboseli"],
      coverImage: zebra,
      itinerary: [
        {
          day: "Day 01",
          title: "Arrival In Nairobi",
          description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)."
        },
        {
          day: "Day 02",
          title: "Nairobi/Mount Kenya National Park",
          description: "After breakfast drive to the Mount Kenya National Park arriving in time for lunch at The Serena Mountain Lodge. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at Serena Mountain Lodge (LDBB)."
        },
        {
          day: "Day 03",
          title: "Mount Kenya National Park/Lake Nakuru National Park",
          description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)."
        },
        {
          day: "Day 04",
          title: "Lake Nakuru National Park/Masai Mara National Reserve",
          description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)."
        },
        {
          day: "Day 05",
          title: "Masai Mara National Reserve",
          description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)."
        },
        {
          day: "Day 06",
          title: "Masai Mara National Reserve/Nairobi/Amboseli National Park",
          description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Amboseli Serena Lodge (LDBB)."
        },
        {
          day: "Day 07",
          title: "Amboseli National Park",
          description: "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Serena Lodge (LDBB)."
        },
        {
          day: "Day 08",
          title: "Amboseli National Park/Nairobi/Departure",
          description: "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
        }
      ]
    },
    {
        id: "JT008",
        name: "Explore Kenya Safari (Classic)",
        duration: "8 Days / 7 Nights",
        description: "An exploratory journey through Kenya's most fascinating wildlife regions and landscapes.",
        highlights: [
          "Diverse wildlife habitats",
          "Expert naturalist guides",
          "Photographic opportunities",
          "Comfortable accommodations"
        ],
        difficulty: "Moderate",
        destinations: ["Masai Mara", "Lake Nakuru", "Mount Kenya", "Amboseli", "Lake Naivasha"],
        coverImage: marasun,
        itinerary: [
          {
            day: "Day 01",
            title: "Arrival In Nairobi",
            description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)."
          },
          {
            day: "Day 02",
            title: "Nairobi/Aberdare National Park",
            description: "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
          },
          {
            day: "Day 03",
            title: "Aberdare National Park/Lake Nakuru National Park/Lake Naivasha",
            description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. After lunch proceed for a game drive and thereafter continue to Lake Naivasha arriving in the late afternoon for dinner and overnight at Naivasha Sopa Lodge (LDBB)."
          },
          {
            day: "Day 04",
            title: "Lake Naivasha/Masai Mara National Reserve",
            description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)."
          },
          {
            day: "Day 05",
            title: "Masai Mara National Reserve",
            description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)."
          },
          {
            day: "Day 06",
            title: "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km park supports a wide range of mammals and birds. Game drive enroute to your lodge. Dinner and overnight at Amboseli Sopa Lodge (LDBB)."
          },
          {
            day: "Day 07",
            title: "Amboseli National Park",
            description: "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Sopa Lodge (LDBB)."
          },
          {
            day: "Day 08",
            title: "Amboseli National Park/Nairobi/Departure",
            description: "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ],
        accommodationSummary: [
          { day: "01", location: "Nairobi", accommodation: "Panafric Hotel", board: "BB", activity: "TRSF" },
          { day: "02", location: "Mount Kenya", accommodation: "The Ark Lodge", board: "LDBB", activity: "GV" },
          { day: "03", location: "Nakuru/Naivasha", accommodation: "Naivasha Sopa Lodge", board: "LDBB", activity: "P" },
          { day: "04", location: "Masai Mara", accommodation: "Mara Sopa Lodge", board: "LDBB", activity: "P" },
          { day: "05", location: "Masai Mara", accommodation: "Mara Sopa Lodge", board: "LDBB", activity: "E,A,P" },
          { day: "06", location: "Amboseli", accommodation: "Amboseli Sopa Lodge", board: "LDBB", activity: "P" },
          { day: "07", location: "Amboseli", accommodation: "Amboseli Sopa Lodge", board: "LDBB", activity: "E,P" },
          { day: "08", location: "Departure", accommodation: "", board: "", activity: "TRSF" }
        ]
      },
      {
        id: "JT009",
        name: "Majestic Kenya Safari (Classic)",
        duration: "8 Days / 7 Nights",
        description: "A majestic journey through Kenya's pristine wilderness and breathtaking landscapes.",
        highlights: [
          "Premium accommodations",
          "Diverse ecosystems",
          "Big Five wildlife viewing",
          "Spectacular scenery"
        ],
        difficulty: "Moderate",
        destinations: ["Nairobi", "Mount Kenya", "Lake Nakuru", "Masai Mara", "Amboseli"],
        coverImage: easymara,
        itinerary: [
          {
            day: "Day 01",
            title: "Arrival In Nairobi",
            description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)."
          },
          {
            day: "Day 02",
            title: "Nairobi/Aberdare National Park",
            description: "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)."
          },
          {
            day: "Day 03",
            title: "Aberdare National Park/Lake Nakuru National Park",
            description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)."
          },
          {
            day: "Day 04",
            title: "Lake Nakuru National Park/Masai Mara National Reserve",
            description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)."
          },
          {
            day: "Day 05",
            title: "Masai Mara National Reserve",
            description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)."
          },
          {
            day: "Day 06",
            title: "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km park supports a wide range of mammals and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic back-drop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Ol Tukai Lodge (LDBB)."
          },
          {
            day: "Day 07",
            title: "Amboseli National Park",
            description: "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Ol Tukai Lodge (LDBB)."
          },
          {
            day: "Day 08",
            title: "Amboseli National Park/Nairobi/Departure",
            description: "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ],
        accommodationSummary: [
          { day: "01", location: "Nairobi", accommodation: "The Stanley Hotel", board: "BB", activity: "TRSF" },
          { day: "02", location: "Mount Kenya", accommodation: "The Ark Lodge", board: "LDBB", activity: "GV" },
          { day: "03", location: "Lake Nakuru", accommodation: "Sarova Lion Hill Lodge", board: "LDBB", activity: "P" },
          { day: "04", location: "Masai Mara", accommodation: "Sarova Mara Camp", board: "LDBB", activity: "P" },
          { day: "05", location: "Masai Mara", accommodation: "Sarova Mara Camp", board: "LDBB", activity: "E,A,P" },
          { day: "06", location: "Amboseli", accommodation: "Ol Tukai Lodge LDBB", board: "LDBB", activity: "P" },
          { day: "07", location: "Amboseli", accommodation: "Ol Tukai Lodge LDBB", board: "LDBB", activity: "E,P" },
          { day: "08", location: "Departure", accommodation: "", board: "", activity: "TRSF" }
        ]
      },
      {
        id: "JT010",
        name: "Kenya Trails Safari (Classic)",
        duration: "6 Days / 5 Nights",
        description: "An immersive journey through Kenya's most iconic wildlife trails and natural landscapes.",
        highlights: [
          "Quintessential Kenya experience",
          "Big Five game viewing",
          "Diverse landscapes",
          "Premium accommodations"
        ],
        difficulty: "Easy to Moderate",
        destinations: ["Nairobi", "Mount Kenya", "Lake Nakuru", "Masai Mara"],
        coverImage: kenyasaf,
        itinerary: [
          {
            day: "Day 01",
            title: "Arrival In Nairobi",
            description: "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)."
          },
          {
            day: "Day 02",
            title: "Nairobi/Mount Kenya National Park",
            description: "After breakfast drive to the Mount Kenya National Park arriving in time for lunch at The Serena Mountain Lodge. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at Serena Mountain Lodge (LDBB)."
          },
          {
            day: "Day 03",
            title: "Mount Kenya National Park/Lake Nakuru National Park",
            description: "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)."
          },
          {
            day: "Day 04",
            title: "Lake Nakuru National Park/Masai Mara National Reserve",
            description: "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)."
          },
          {
            day: "Day 05",
            title: "Masai Mara National Reserve",
            description: "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)."
          },
          {
            day: "Day 06",
            title: "Masai Mara National Reserve/Nairobi/Departure",
            description: "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ],
        accommodationSummary: [
          { day: "01", location: "Nairobi", accommodation: "Nairobi Serena Hotel", board: "BB", activity: "TRSF" },
          { day: "02", location: "Mount Kenya", accommodation: "Mountain Lodge", board: "LDBB", activity: "GV" },
          { day: "03", location: "Lake Nakuru", accommodation: "Flamingo Hill Tented Camp", board: "LDBB", activity: "P" },
          { day: "04", location: "Masai Mara", accommodation: "Mara Serena Lodge", board: "LDBB", activity: "P" },
          { day: "05", location: "Masai Mara", accommodation: "Mara Serena Lodge", board: "LDBB", activity: "E,A,P" },
          { day: "06", location: "Departure", accommodation: "", board: "", activity: "TRSF" }
        ]
      },
      {
        id: "JT011",
        name: "Discover Kenya Safari (Classic)",
        duration: "6 Days / 5 Nights",
        description: "A perfect introduction to Kenya's wildlife and landscapes for first-time safari-goers.",
        highlights: [
          "Aberdare National Park tree lodge",
          "Lake Nakuru and Lake Naivasha exploration",
          "Masai Mara extensive game drives",
          "Optional balloon safari"
        ],
        difficulty: "Easy",
        destinations: ["Mount Kenya", "Lake Nakuru", "Lake Naivasha", "Masai Mara"],
        coverImage: grand,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)"
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Aberdare National Park",
            "description": "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)"
          },
          {
            "day": "Day 03",
            "title": "Aberdare National Park/Lake Nakuru National Park/Lake Naivasha",
            "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. After lunch proceed for a game drive and thereafter continue to Lake Naivasha arriving in the late afternoon for dinner and overnight at Lake Naivasha Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 04",
            "title": "Lake Naivasha/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 05",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 06",
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in."
          }
        ]
      },
      {
        id: "JT012",
        name: "Simba Safari (Classic)",
        duration: "6 Days / 5 Nights",
        description: "Follow in the footsteps of lions on this classic Kenya safari experience.",
        highlights: [
          "Aberdare National Park tree lodge experience",
          "Lake Nakuru National Park wildlife viewing",
          "Masai Mara extensive game drives",
          "Optional balloon safari"
        ],
        difficulty: "Easy",
        destinations: ["Aberdare", "Lake Nakuru", "Masai Mara"],
        coverImage: karibu,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)"
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Aberdare National Park",
            "description": "After breakfast drive to the Aberdares arriving in time for lunch at The Aberdare Country Club. After lunch transfer to the lodge situated inside the Aberdare National Park. Rest of the day at leisure with game viewing from the lodge. Dinner and overnight at The Ark Lodge (LDBB)"
          },
          {
            "day": "Day 03",
            "title": "Aberdare National Park/Lake Nakuru National Park",
            "description": "After breakfast you will be collected for the day's drive, via the Nyahururu waterfalls to the floor of the Great Rift Valley, destination Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)"
          },
          {
            "day": "Day 04",
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": "Day 05",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": "Day 06",
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT013",
        name: "Kenya Plains & Safari (Classic)",
        duration: "7 Days / 6 Nights",
        description: "Discover the magnificent plains of Kenya and witness diverse wildlife in their natural habitats.",
        highlights: [
          "Lake Nakuru flamingo viewing",
          "Masai Mara Big Five sightings",
          "Optional hot air balloon safari",
          "Amboseli with Mt. Kilimanjaro backdrop"
        ],
        difficulty: "Easy",
        destinations: ["Lake Nakuru", "Masai Mara", "Amboseli"],
        coverImage: twiga,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)"
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Lake Nakuru National Park",
            "description": "After breakfast drive to Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)"
          },
          {
            "day": "Day 03",
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": "Day 04",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": "Day 05",
            "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Amboseli Serena Lodge (LDBB)"
          },
          {
            "day": "Day 06",
            "title": "Amboseli National Park",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Serena Lodge (LDBB)"
          },
          {
            "day": "Day 07",
            "title": "Amboseli National Park/Nairobi/Departure",
            "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT014",
        name: "Ndovu Trail (Classic)",
        duration: "7 Days / 6 Nights",
        description: "Experience Kenya's stunning landscapes and abundant wildlife on this classic safari trail.",
        highlights: [
          "Lake Naivasha and Lake Nakuru exploration",
          "Masai Mara game drives",
          "Optional balloon safari experience",
          "Mount Kilimanjaro views from Amboseli"
        ],
        difficulty: "Easy",
        destinations: ["Lake Naivasha", "Lake Nakuru", "Masai Mara", "Amboseli"],
        coverImage: amboseli,
        itinerary: [
          {
            "day": "Day 01",
            "title": "Arrival In Nairobi",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by an Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)"
          },
          {
            "day": "Day 02",
            "title": "Nairobi/Lake Nakuru National Park/Lake Naivasha",
            "description": "After breakfast drive to Lake Naivasha for lunch at your lodge. After lunch proceed for a game drive to Lake Nakuru National Park. Thereafter drive back to Lake Naivasha. Dinner and overnight at Lake Naivasha Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 03",
            "title": "Lake Naivasha/Masai Mara National Reserve",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 04",
            "title": "Masai Mara National Reserve",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 05",
            "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Amboseli Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 06",
            "title": "Amboseli National Park",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Amboseli Sopa Lodge (LDBB)"
          },
          {
            "day": "Day 07",
            "title": "Amboseli National Park/Nairobi/Departure",
            "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT015",
        name: "KENYA FRONTIERS SAFARI (CLASSIC)",
        duration: "7 days",
        description: "Experience the magnificent wildlife and landscapes of Kenya with this comprehensive 7-day safari adventure. This journey takes you through Lake Nakuru National Park, the iconic Masai Mara National Reserve, and Amboseli National Park with its breathtaking views of Mount Kilimanjaro.",
        highlights: [
          "Visit to Lake Nakuru National Park, famous for its flamingos and rhino sanctuary",
          "Extended stay in the Masai Mara, home to the great wildebeest migration",
          "Optional hot air balloon safari with champagne breakfast",
          "Amboseli National Park with views of Mount Kilimanjaro",
          "Game drives to spot Africa's Big Five and other wildlife",
          "Lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Lake Nakuru", "Masai Mara", "Amboseli"],
        coverImage: naivasha,
        itinerary: [
          {
            "day": 1,
            "title": "Arrival In Nairobi",
            "location": "Nairobi",
            "accommodation": "The Stanley Hotel",
            "board": "BB",
            "activity": "TRSF",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)"
          },
          {
            "day": 2,
            "title": "Nairobi/Lake Nakuru National Park",
            "location": "Lake Nakuru",
            "accommodation": "Sarova Lion Hill Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast drive to Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)"
          },
          {
            "day": 3,
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 4,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "E,A,P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 5,
            "title": "Masai Mara National Reserve/Nairobi/Amboseli National Park",
            "location": "Amboseli",
            "accommodation": "Ol Tukai Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drive to Amboseli National Park, lying below the most famous symbol of Africa, Mount Kilimanjaro. The 392 sq km Amboseli National Park lies due south of Nairobi, within clear sight of Mt Kilimanjaro, Africa's highest mountain at 5896 metres. The waters of the mountain feed the seasonal swamps and marshes on which the game and birds, which live in the park, rely. It is here that photographers will hope to shoot the classic picture of the elephant or giraffe standing against the dramatic backdrop of the snow capped mountain. Game drive enroute to your lodge. Dinner and overnight at Ol Tukai Lodge (LDBB)"
          },
          {
            "day": 6,
            "title": "Amboseli National Park",
            "location": "Amboseli",
            "accommodation": "Ol Tukai Lodge",
            "board": "LDBB",
            "activity": "E,P",
            "description": "Early morning game drive returning to the lodge for breakfast. Rest of the morning at leisure. Lunch. Afternoon game drive. Dinner and overnight at Ol Tukai Lodge (LDBB)"
          },
          {
            "day": 7,
            "title": "Amboseli National Park/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast, drive to Nairobi and drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT016",
        name: "MIGRATION SAFARI (CLASSIC)",
        duration: "5 days",
        description: "Experience the wonder of Kenya's wildlife with this 5-day Migration Safari. This journey focuses on Lake Nakuru National Park and the world-renowned Masai Mara National Reserve, home to the spectacular Great Migration.",
        highlights: [
          "Game viewing at Lake Nakuru National Park, with its flamingos and rhino sanctuary",
          "Two full days in the Masai Mara, perfect for witnessing the great wildebeest migration",
          "Optional hot air balloon safari with champagne breakfast",
          "Spectacular game drives to spot Africa's iconic wildlife",
          "Lunch at the famous Carnivore Restaurant in Nairobi",
          "Comfortable accommodations at Serena properties"
        ],
        destination: ["Nairobi", "Lake Nakuru", "Masai Mara"],
        coverImage: mara,
        itinerary: [
          {
            "day": 1,
            "title": "Arrival In Nairobi",
            "location": "Nairobi",
            "accommodation": "Nairobi Serena Hotel",
            "board": "BB",
            "activity": "TRSF",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Nairobi Serena Hotel (BB)"
          },
          {
            "day": 2,
            "title": "Nairobi/Lake Nakuru National Park",
            "location": "Lake Nakuru",
            "accommodation": "Flamingo Hill Tented Camp",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast drive to Lake Nakuru National Park arriving in time for lunch at the camp. Afternoon game drive. Dinner and overnight at Flamingo Hill Tented Camp (LDBB)"
          },
          {
            "day": 3,
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Serena Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": 4,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Serena Lodge",
            "board": "LDBB",
            "activity": "E,A,P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": 5,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT017",
        name: "MAASAI SAFARI (CLASSIC)",
        duration: "5 days",
        description: "Immerse yourself in Kenya's breathtaking landscapes and diverse wildlife with this 5-day Maasai Safari. Explore Lake Nakuru National Park, Lake Naivasha, and the iconic Masai Mara National Reserve with its abundant wildlife.",
        highlights: [
          "Visit to Lake Nakuru National Park, renowned for its flamingos and rhino sanctuary",
          "Stay at Lake Naivasha, home to hippos and diverse birdlife",
          "Two nights in the world-famous Masai Mara National Reserve",
          "Optional hot air balloon safari with champagne breakfast",
          "Multiple game drives to spot Africa's Big Five and other wildlife",
          "Lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Lake Nakuru", "Lake Naivasha", "Masai Mara"],
        coverImage: zebra,
        itinerary: [
          {
            "day": 1,
            "title": "Arrival In Nairobi",
            "location": "Nairobi",
            "accommodation": "Panafric Hotel",
            "board": "BB",
            "activity": "TRSF",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Panafric Hotel (BB)"
          },
          {
            "day": 2,
            "title": "Nairobi/Lake Nakuru National Park/Lake Naivasha",
            "location": "Nakuru/Naivasha",
            "accommodation": "Naivasha Sopa Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast drive to Lake Naivasha for lunch at your lodge. After lunch proceed for a game drive to Lake Nakuru National Park. Thereafter drive back to Lake Naivasha. Dinner and overnight at Lake Naivasha Sopa Lodge (LDBB)"
          },
          {
            "day": 3,
            "title": "Lake Naivasha/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Sopa Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": 4,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Sopa Lodge",
            "board": "LDBB",
            "activity": "E, A, P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": 5,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT018",
        name: "SAFARI ROYALE (CLASSIC)",
        duration: "5 days",
        description: "Experience a royal safari adventure through Kenya's most spectacular wildlife reserves. This 5-day journey takes you through Lake Nakuru National Park and the magnificent Masai Mara National Reserve, combining comfort with extraordinary wildlife viewing.",
        highlights: [
          "Exploration of Lake Nakuru National Park, famous for its flamingos and rhino sanctuary",
          "Extended stay in the world-renowned Masai Mara National Reserve",
          "Optional hot air balloon safari with champagne breakfast",
          "Multiple game drives to spot Africa's iconic wildlife including the Big Five",
          "Luxury accommodations at Sarova properties throughout the safari",
          "Farewell lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Lake Nakuru", "Masai Mara"],
        coverImage: marasun,
        itinerary: [
          {
            "day": 1,
            "title": "Arrival In Nairobi",
            "location": "Nairobi",
            "accommodation": "The Stanley Hotel",
            "board": "BB",
            "activity": "TRSF",
            "description": "Met upon arrival at Jomo Kenyatta International Airport by a Jambo Tours representative. Assistance and transfer to your hotel. Rest of the day at leisure. Accommodation on bed & breakfast basis at The Stanley Hotel (BB)"
          },
          {
            "day": 2,
            "title": "Nairobi/Lake Nakuru National Park",
            "location": "Lake Nakuru",
            "accommodation": "Sarova Lion Hill Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast drive to Lake Nakuru National Park arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Lion Hill Lodge (LDBB)"
          },
          {
            "day": 3,
            "title": "Lake Nakuru National Park/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 4,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "E,A,P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 5,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT019",
        name: "MARA SERENADE EXPERIENCE (CLASSIC)",
        duration: "3 days",
        description: "Embark on a short but memorable safari experience to Kenya's premier wildlife destination, the Masai Mara National Reserve. This 3-day adventure offers exceptional game viewing opportunities and comfortable accommodation at the renowned Mara Serena Lodge.",
        highlights: [
          "Focus on the world-famous Masai Mara National Reserve",
          "Opportunity to witness the spectacular wildlife including the Big Five",
          "Optional hot air balloon safari with champagne breakfast",
          "Morning and afternoon game drives for maximum wildlife exposure",
          "Comfortable stay at the strategically located Mara Serena Lodge",
          "Farewell lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Masai Mara"],
        coverImage: easymara,
        itinerary: [
          {
            "day": 1,
            "title": "Nairobi/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Serena Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": 2,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Serena Lodge",
            "board": "LDBB",
            "activity": "E, A, P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Serena Lodge (LDBB)"
          },
          {
            "day": 3,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT020",
        name: "MARA CLASSIC EXPERIENCE (CLASSIC)",
        duration: "3 days",
        description: "Experience the wonders of Kenya's most famous wildlife reserve with this 3-day Mara Classic Experience. This safari focuses exclusively on the Masai Mara National Reserve, providing ample opportunity to witness its incredible biodiversity and breathtaking landscapes.",
        highlights: [
          "Concentrated safari experience in the world-renowned Masai Mara National Reserve",
          "Multiple game drives to maximize wildlife viewing opportunities",
          "Optional hot air balloon safari with champagne breakfast",
          "Comfortable accommodation at the popular Mara Sopa Lodge",
          "Opportunity to witness the Big Five and other iconic African wildlife",
          "Farewell lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Masai Mara"],
        coverImage: kenyasaf,
        itinerary: [
          {
            "day": 1,
            "title": "Nairobi/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Sopa Lodge",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": 2,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Mara Sopa Lodge",
            "board": "LDBB",
            "activity": "E, A, P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Mara Sopa Lodge (LDBB)"
          },
          {
            "day": 3,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. An Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      },
      {
        id: "JT021",
        name: "MARA PREMIUM EXPERIENCE (CLASSIC)",
        duration: "3 days",
        description: "Indulge in a premium safari experience in Kenya's magnificent Masai Mara National Reserve. This 3-day adventure offers superior accommodation at the Sarova Mara Camp and excellent wildlife viewing opportunities in one of Africa's most renowned wildlife sanctuaries.",
        highlights: [
          "Exclusive focus on the legendary Masai Mara National Reserve",
          "Premium accommodation at the luxurious Sarova Mara Camp",
          "Multiple game drives to spot the Big Five and other iconic wildlife",
          "Optional hot air balloon safari with champagne breakfast",
          "Personalized service and authentic safari experience",
          "Farewell lunch at the famous Carnivore Restaurant in Nairobi"
        ],
        destination: ["Nairobi", "Masai Mara"],
        coverImage: grand,
        itinerary: [
          {
            "day": 1,
            "title": "Nairobi/Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "P",
            "description": "After breakfast, drive to the Masai Mara National Reserve offering wonderful scenery and plenty of game. It is perhaps the only region left in Kenya where the visitor may see animals in the same super-abundance as existed a century ago, arriving in time for lunch at the lodge. Afternoon game drive. Dinner and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 2,
            "title": "Masai Mara National Reserve",
            "location": "Masai Mara",
            "accommodation": "Sarova Mara Camp",
            "board": "LDBB",
            "activity": "E, A, P",
            "description": "(Early morning optional balloon ride with champagne-style breakfast.) Full day in Masai Mara with morning and afternoon game drives. All meals and overnight at Sarova Mara Camp (LDBB)"
          },
          {
            "day": 3,
            "title": "Masai Mara National Reserve/Nairobi/Departure",
            "activity": "TRSF",
            "description": "After breakfast drive to Nairobi arriving in time for lunch at The Carnivore Restaurant. After lunch drop off at your hotel or Jomo Kenyatta Airport for your departure flight back home. A Jambo Tours representative will re-confirm your onward flight, and assist you at check-in. End of our services."
          }
        ]
      }
    ];

    // Activity code meanings
    export const activityCodes = {
      "L": "Lunch",
      "D": "Dinner",
      "BB": "Bed and breakfast",
      "LDBB": "Lunch, dinner, bed and breakfast",
      "TRSF": "Transfer",
      "E": "Early morning game drive",
      "A": "Morning game drive",
      "P": "Afternoon game drive",
      "GV": "Game Viewing",
      "FLT": "Flight"
    };
